import { useIdle } from '@vueuse/core'

export default function onIdle(){
    const { idle } = useIdle(15 * 60 * 1000)

    setInterval(() => {
        if (idle.value) {
            window.location.href = '/logout'
        }
    }, 5000);
}
